import axios from "axios";
import { ELVIS_URL } from 'helpers/urlHelper';

axios.defaults.withCredentials = true;

const fetchKnowledgeBases = async () => {
    try {
        const response = await axios.get(`${ELVIS_URL}/api/knowledge-base`);
        if (response.status == 200)
            return response.data;
        else
            throw new Error('Unable to load knowledge bases.');
    } catch (err) {
        console.log(err);
        throw (err);
    }
}

const uploadFile = async formData => {
    try {
        const response = await axios.post(`${ELVIS_URL}/api/knowledge-base/upload`, formData);
        if (response.status == 200)
            return true;

        throw new Error(`Upload failed with status ${response.status}.`);
    } catch (err) {
        console.log(err);
        throw (err);
    }
}

const deleteFile = async payload => {
    try {
        const response = await axios.post(`${ELVIS_URL}/api/knowledge-base/remove`, payload)
        return response.status == 200;
    } catch (err) {
        console.log(err);
        throw (err);
    }
}

export { fetchKnowledgeBases, uploadFile, deleteFile };